var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultichain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.3 44",
    style: {
      enableBackground: "new 0 0 43.3 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -183.6324,
    y1: 267.7147,
    x2: -184.6324,
    y2: 266.7272,
    gradientTransform: "matrix(43.273 0 0 -43 7989.5977 11512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5F6BFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#724DE4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.4,0H13.9C6.2,0,0,6.1,0,13.8v15.4C0,36.9,6.2,43,13.9,43h15.5c7.7,0,13.9-6.1,13.9-13.8V13.8 C43.3,6.1,37.1,0,29.4,0L29.4,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,19.3c-1.4,1.4-2,3.4-1.5,5.3s1.9,3.3,3.8,3.8c1.9,0.5,3.9-0.1,5.3-1.5l9.4-9.3c1.3-1.3,3.5-1.3,4.7-0.1 s1.3,3.4-0.1,4.7l-3,3L27,23.5l-1.2,6.1l6.1-1.2l-1.7-1.7l3-3c1.4-1.4,2-3.4,1.5-5.3c-0.5-1.9-1.9-3.3-3.8-3.8 c-1.9-0.5-3.9,0.1-5.3,1.5l-9.4,9.3c-1.3,1.3-3.5,1.3-4.7,0.1s-1.3-3.4,0.1-4.7l2.8-2.8l1.7,1.7l1.2-6.1l-6.1,1.2l1.7,1.7L10,19.3 L10,19.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultichain);
export default __webpack_public_path__ + "static/media/multichain.1fec73977cd7846a33e2786af2162cbc.svg";
export { ForwardRef as ReactComponent };